import React from "react";
import { Link } from "react-router-dom";

class NotFound extends React.Component {
  render() {
    return (
      <div style={styles.wrapper}>
        404 page not found.&nbsp;&nbsp;
        <Link to={this.props.homePath}> Go to home</Link>
      </div>
    );
  }
}

const styles = {
  wrapper: {
    width: "100%",
    height: "100vh",
    background: "#f5f5f5",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
};

export default NotFound;
